import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageAttachment: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageAttachment"><Path d="M11.5 2.5H19.5V21.5H4.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 8.5V4C5.5 3.17157 6.17157 2.5 7 2.5C7.82843 2.5 8.5 3.17157 8.5 4V8.5C8.5 10.1569 7.15685 11.5 5.5 11.5C3.84315 11.5 2.5 10.1569 2.5 8.5V4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageAttachment;
